import {useRef} from 'react';
import List from '../../../../../../component/list/List';
import useShow from '../../../../../../hooks/useShow';
import {op} from '../../../../../../assets/symbols/symbols/Symbols.css';
import * as menuCss from './PriceGroupMenuButton/PriceGroupMenuButton.css';

interface MenuOption {
    text: string;
    onClick: () => void;
    icon: string;
    dataCyName: string;
}

interface UseMenuButtonReturn {
    menuIcon: JSX.Element;
    menuList: JSX.Element | null;
}

export function useMenuButton(menuOptions: MenuOption[]): UseMenuButtonReturn {
    const menuShow = useShow();
    const refMenu = useRef<HTMLDivElement>(null);

    const handleToggleMenu = (e: React.MouseEvent) => {
        e.stopPropagation();
        if(menuShow.isOpen) {
            menuShow.close();
        } else {
            menuShow.open();
        }
    };

    const menuIcon = (
        <menuCss.menuIconWrapper onClick={handleToggleMenu} ref={refMenu}>
            <menuCss.menuIcon icon={op} />
        </menuCss.menuIconWrapper>
    );

    const menuList = menuShow.isOpen && refMenu.current ? (
        <List
            list={menuOptions}
            top={27}
            width="180px"
            showClass={menuShow.showClass}
            close={menuShow.close}
            left={refMenu.current.getBoundingClientRect().x + 'px'}
            fixedTop={refMenu.current.getBoundingClientRect().y}
        />
    ) : null;

    return {menuIcon, menuList};
}

